<mat-card>
  <mat-card-header class="knowledge-access-header">
    <mat-card-title class="Knowledge-card-title">
      <mat-icon svgIcon="ai-knowledge-icon" class="knowledge-icon" matListItemIcon></mat-icon>
      {{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.KNOWLEDGE_ACCESS' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="knowledge-access-content">
    @for (knowledgeForm of knowledgeFormArray().controls; track knowledgeForm; let i = $index) {
      <ai-assistant-knowledge-access-form [form]="knowledgeForm" (remove)="removeKnowledgeForm(i)">
      </ai-assistant-knowledge-access-form>
    }
  </mat-card-content>
  <mat-card-actions align="end" class="knowledge-access-actions">
    <button mat-stroked-button (click)="openAddKnowledgeModal()">
      {{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.ADD_KNOWLEDGE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
